import { Extension } from '@tiptap/react';

export const NonBreakingSpaceOnSpace = Extension.create({
  name: 'nonBreakingSpaceOnSpace',
  addKeyboardShortcuts() {
    return {
      Space: () => {
        const { state } = this.editor;
        const { from } = state.selection;
        const prevChar = state.doc.textBetween(from - 1, from);

        // Only replace if previous char is already a space
        if (prevChar === ' ') {
          this.editor.commands.insertContent('\u00A0');
          return true;
        }

        return false; // allow normal space
      },
    };
  },
});

export default NonBreakingSpaceOnSpace;
